/**
 * Checks if any account flag has a string value
 * Used to detect if flags have been populated with actual values
 * 
 * @param accountFlags - The account flags object to check
 * @returns boolean - True if any flag has a string value
 */
export function checkAcknowledgedFlags(accountFlags: Record<string, any> = {}): boolean {
  // Check just the flags object
  const flags = accountFlags.flags || {}
  
  for (const moduleKey in flags) {
    const module = flags[moduleKey]
    
    // Check if any property in this module is a string
    for (const propKey in module) {
      if (typeof module[propKey] === 'string') {
        return true
      }
    }
  }
  
  return false
}